import React from "react"

interface IProps {
  fallback?: React.ReactNode
}

interface IState {
  hasError: boolean
}

// Catches render/lifecycle errors thrown by its children and renders `fallback` (nothing,
// by default) instead of crashing the whole app. Use around components whose failure
// shouldn't take down everything else - e.g. third-party embeds or "dangerous" DOM hacks.
class ErrorBoundary extends React.Component<React.PropsWithChildren<IProps>, IState> {
  state: IState = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: Error) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught an error:", error)
  }

  render() {
    if (this.state.hasError) { return this.props.fallback ?? null }
    return this.props.children
  }
}

export default ErrorBoundary
